<template>
  <div class="v-common-attr">
    <el-collapse
      v-model="activeName"
      accordion
      @change="onChange"
    >
      <el-collapse-item
        title="通用样式"
        name="style"
      >
        <el-form label-width="90px">
          <el-form-item
            v-for="({ key, label }, index) in styleKeys"
            :key="index"
            :label="label"
          >
            <el-color-picker
              v-if="isIncludesColor(key)"
              v-model="curComponent.style[key]"
              color-format="rgb"
            />
            <el-color-picker
              v-else-if="key === 'frameColor'"
              v-model="curComponent.style[key]"
              color-format="rgb"
            />
            <el-color-picker
              v-else-if="key === 'lineColor'"
              v-model="curComponent.style[key]"
              color-format="rgb"
            />
            <el-color-picker
              v-else-if="key === 'backgroundColor'"
              v-model="curComponent.style[key]"
              color-format="rgb"
            />
            <el-input-number
              v-else-if="key === 'frameWeight'"
              v-model="curComponent.style[key]"
            />
            <el-select
              v-else-if="selectKey.includes(key)"
              v-model="curComponent.style[key]"
            >
              <el-option
                v-for="item in optionMap[key]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-select
              v-else-if="key === 'colAligns'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="靠左"
                :value="0"
              />
              <el-option
                label="居中"
                :value="1"
              />
              <el-option
                label="靠右"
                :value="2"
              />
            </el-select>
            <el-select
              v-else-if="key === 'halign'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="靠左"
                :value="0"
              />
              <el-option
                label="居中"
                :value="1"
              />
              <el-option
                label="靠右"
                :value="2"
              />
            </el-select>
            <div v-else-if="key === 'tableHeadFontSize'">
              <el-input-number v-model="curComponent.style[key]" />
            </div>
            <div v-else-if="key === 'tableBodyFontSize'">
              <el-input-number v-model="curComponent.style[key]" />
            </div>

            <el-select
              v-else-if="key === 'valign'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="靠上"
                :value="0"
              />
              <el-option
                label="居中"
                :value="1"
              />
              <el-option
                label="靠下"
                :value="2"
              />
            </el-select>
            <!-- <el-select
              v-else-if="key === 'wordWrap'"
              v-model="curComponent.style[key]"
            >
              <el-option label="否" :value="0" />
              <el-option label="是" :value="1" />
            </el-select> -->
            <el-select
              v-else-if="key === 'inMethod'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="随机"
                :value="0"
              />
              <el-option
                label="立即显示"
                :value="1"
              />
              <el-option
                label="左滚显示"
                :value="2"
              />
              <el-option
                label="上滚显示"
                :value="3"
              />
              <el-option
                label="右滚显示"
                :value="4"
              />
              <el-option
                label="下滚显示"
                :value="5"
              />
              <el-option
                label="连续左滚显示"
                :value="6"
              />
              <el-option
                label="连续右滚显示"
                :value="8"
              />
              <el-option
                label="从右向左移入"
                :value="13"
              />
              <el-option
                label="从左向右移入"
                :value="14"
              />
              <el-option
                label="从右上角移入"
                :value="17"
              />
              <el-option
                label="从右下角移入"
                :value="18"
              />
              <el-option
                label="从左上角移入"
                :value="19"
              />
              <el-option
                label="从左下角移入"
                :value="20"
              />
              <el-option
                label="从上向下移入"
                :value="21"
              />
              <el-option
                label="从下向上移入"
                :value="22"
              />
              <el-option
                label="横向百叶窗"
                :value="23"
              />
              <el-option
                label="纵向百叶窗"
                :value="24"
              />
              <template
                v-if="
                  curComponent.component!=='LProjectInfo'&&
                    curComponent.component!=='LCompanyName'&&
                    curComponent.component!=='LSiteCount'&&
                    curComponent.component!=='LTeamCount'&&
                    curComponent.component!=='LWorkCount'&&
                    curComponent.component!=='LRecord'
                "
              >
                <el-option
                  label="连续上滚显示"
                  :value="7"
                />
                <el-option
                  label="连续下滚显示"
                  :value="9"
                />
                <el-option
                  label="中间向上下展开"
                  :value="10"
                />
                <el-option
                  label="中间向两边展开"
                  :value="11"
                />
                <el-option
                  label="中间向四周展开"
                  :value="12"
                />
                <el-option
                  label="从左向右展开"
                  :value="15"
                />
                <el-option
                  label="从右向左展开"
                  :value="16"
                />
              </template>
            </el-select>
            <el-select
              v-else-if="key === 'inSpeed'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="一级速度"
                :value="0"
              />
              <el-option
                label="二级速度"
                :value="1"
              />
              <el-option
                label="三级速度"
                :value="2"
              />
              <el-option
                label="四级速度"
                :value="3"
              />
              <el-option
                label="五级速度"
                :value="4"
              />
              <el-option
                label="六级速度"
                :value="5"
              />
            </el-select>
            <el-select
              v-else-if="key === 'outMethod'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="随机"
                :value="0"
              />
              <el-option
                label="始终显示"
                :value="1"
              />
              <el-option
                label="立即消失"
                :value="2"
              />
              <el-option
                label="从左向右移出"
                :value="6"
              />
              <el-option
                label="从右向左移出"
                :value="7"
              />
              <el-option
                label="从右下角移出"
                :value="11"
              />
              <el-option
                label="从左下角移出"
                :value="13"
              />
              <el-option
                label="从上向下移出"
                :value="15"
              />
              <el-option
                label="横向百叶窗"
                :value="16"
              />
              <el-option
                label="纵向百叶窗"
                :value="17"
              />
              <template
                v-if="
                  curComponent.component!=='LProjectInfo'&&
                    curComponent.component!=='LCompanyName'&&
                    curComponent.component!=='LSiteCount'&&
                    curComponent.component!=='LTeamCount'&&
                    curComponent.component!=='LWorkCount'&&
                    curComponent.component!=='LRecord'
                "
              >
                <el-option
                  label="上下向中间合拢"
                  :value="3"
                />
                <el-option
                  label="两边向中间合拢"
                  :value="4"
                />
                <el-option
                  label="四周向中间合拢"
                  :value="5"
                />
                <el-option
                  label="从右向左合拢"
                  :value="8"
                />
                <el-option
                  label="从左向右合拢"
                  :value="9"
                />
                <el-option
                  label="从右上角移出"
                  :value="10"
                />
                <el-option
                  label="从左上角移出"
                  :value="12"
                />
                <el-option
                  label="从下向上移出"
                  :value="14"
                />
              </template>
            </el-select>
            <el-select
              v-else-if="key === 'outSpeed'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="一级速度"
                :value="0"
              />
              <el-option
                label="二级速度"
                :value="1"
              />
              <el-option
                label="三级速度"
                :value="2"
              />
              <el-option
                label="四级速度"
                :value="3"
              />
              <el-option
                label="五级速度"
                :value="4"
              />
              <el-option
                label="六级速度"
                :value="5"
              />
            </el-select>
            <el-select
              v-else-if="key === 'stopMethod'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="静态显示"
                :value="0"
              />
              <el-option
                label="闪烁显示"
                :value="1"
              />
            </el-select>
            <el-select
              v-else-if="key === 'stopSpeed'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="一级速度"
                :value="0"
              />
              <el-option
                label="二级速度"
                :value="1"
              />
              <el-option
                label="三级速度"
                :value="2"
              />
              <el-option
                label="四级速度"
                :value="3"
              />
              <el-option
                label="五级速度"
                :value="4"
              />
              <el-option
                label="六级速度"
                :value="5"
              />
            </el-select>
            <el-select
              v-else-if="key === 'formats'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="年月日 时分秒"
                :value="1"
              />
              <el-option
                label="星期"
                :value="2"
              />
              <el-option
                label="年月日 "
                :value="3"
              />
              <el-option
                label="时分秒"
                :value="4"
              />
            </el-select>
            <el-select
              v-else-if="key === 'format'"
              v-model="curComponent.style[key]"
            >
              <el-option
                label="时分秒"
                :value="0"
              />
              <el-option
                label="时分"
                :value="1"
              />
              <el-option
                label="分秒"
                :value="2"
              />
            </el-select>
            <el-select
              v-else-if="key === 'type'"
              v-model="curComponent.style[key]"
            >
              <el-option
                v-if="curComponent.style['countType'] === 0"
                label="从指定时间开始正计时"
                :value="0"
              />
              <el-option
                v-if="curComponent.style['countType'] === 1"
                label="距离目标倒计时"
                :value="1"
              />
              <el-option
                v-if="curComponent.style['countType'] === 0"
                label="普通正计时"
                :value="2"
              />
              <el-option
                v-if="curComponent.style['countType'] === 1"
                label="普通倒计时"
                :value="3"
              />
            </el-select>
            <div v-else-if="key === 'stopTime'">
              <el-input-number
                v-model="curComponent.style[key]"
                style="margin-right:4px"
              />
              <span>毫秒</span>
            </div>
            <div v-else-if="key === 'fontSize'">
              <el-input-number v-model="curComponent.style[key]" />
            </div>

            <el-input
              v-else
              v-model="curComponent.style[key]"
            />
          </el-form-item>
          <el-form-item
            v-if="curComponent.style.type === 0"
            label="开始时间"
          >
            <el-date-picker
              v-model="datetime"
              type="datetime"
              placeholder="选择日期时间"
              @change="datetimeChange"
            />
          </el-form-item>
          <el-form-item
            v-if="curComponent.style.type === 1"
            label="结束时间"
          >
            <el-date-picker
              v-model="datetime"
              type="datetime"
              placeholder="选择日期时间"
              @change="datetimeChange"
            />
          </el-form-item>
          <el-form-item
            v-if="
              curComponent.style.type === 2 || curComponent.style.type === 3
            "
            label="计时时间"
          >
            <el-time-picker
              v-model="time"
              placeholder="任意时间点"
              @change="timeChange"
            />
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <!-- <Request v-if="curComponent.request" /> -->
      <!-- <Linkage v-if="curComponent.linkage" /> -->
    </el-collapse>
  </div>
</template>

<script>
import {
  styleData1,
  textAlignOptions,
  borderStyleOptions,
  verticalAlignOptions,
  selectKey,
  optionMap
} from '@/utils/attr'
import moment from 'moment'
// import Request from './Request'
// import Linkage from './Linkage.vue'

export default {
  components: {},
  data() {
    return {
      optionMap,
      styleData1,
      textAlignOptions,
      borderStyleOptions,
      verticalAlignOptions,
      selectKey,
      activeName: '',
      datetime: '',
      time: new Date(2016, 9, 0, 0, 0, 30)
    }
  },
  computed: {
    styleKeys() {
      if (this.curComponent) {
        const curComponentStyleKeys = Object.keys(this.curComponent.style)
        return this.styleData1.filter((item) =>
          curComponentStyleKeys.includes(item.key)
        )
      }

      return []
    },
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  },
  created() {
    this.activeName = this.curComponent.collapseName
    if (this.curComponent.style.isEdit === 0) {
      this.datetime = moment().format('YYYY-MM-DD HH:mm:ss')
      if (this.curComponent.style.type === 1) {
        this.datetime = moment(this.datetime)
          .add(1, 'day')
          .format('YYYY-MM-DD HH:mm:ss')
      }
      this.curComponent.style.year = moment(this.datetime).get('year')
      this.curComponent.style.month = this.addZero(
        moment(this.datetime).get('month')
      )
      this.curComponent.style.day = moment(this.datetime).get('date')
      this.curComponent.style.hour = moment(this.datetime).get('hour')
      this.curComponent.style.minute = moment(this.datetime).get('minute')
      this.curComponent.style.second = moment(this.datetime).get('second')
    } else {
      const date = `${this.curComponent.style.year}-${this.curComponent.style.month}-${this.curComponent.style.day} ${this.curComponent.style.hour}:${this.curComponent.style.minute}:${this.curComponent.style.second}`
      this.datetime = moment(date).format('YYYY-MM-DD HH:mm:ss')
    }

    // if (this.curComponent.style.paramType === '3') {
    //   this.curComponent.style.
    // }
  },
  methods: {
    onChange() {
      this.curComponent.collapseName = this.activeName
    },

    isIncludesColor(str) {
      return str.toLowerCase().includes('color')
    },
    datetimeChange(e) {
      this.$set(this.curComponent.style, 'year', moment(e).get('year'))
      this.$set(
        this.curComponent.style,
        'month',
        this.addZero(moment(e).get('month'))
      )
      this.$set(this.curComponent.style, 'day', moment(e).get('date'))
      this.$set(this.curComponent.style, 'hour', moment(e).get('hour'))
      this.$set(this.curComponent.style, 'minute', moment(e).get('minute'))
      this.$set(this.curComponent.style, 'second', moment(e).get('second'))
    },
    timeChange(e) {
      this.$set(this.curComponent.style, 'hour', moment(e).get('hour'))
      this.$set(this.curComponent.style, 'minute', moment(e).get('minute'))
      this.$set(this.curComponent.style, 'second', moment(e).get('second'))
    },
    addZero(e) {
      return e + 1
    }
  }
}
</script>

<style lang="scss">
.v-common-attr {
  .el-input-group__prepend {
    padding: 0 10px;
  }
}
</style>
